<div class="final-treatment-container" [ngClass]="blinkClass">
  <div class="final-treatment-child">
    <div class="item-final">
      <div class="part-left" *ngIf="dayDifference > 0">
        {{ dayDifference }}日
      </div>
      <div class="part-right">
        <div>{{ hasExcreationRecord ? (hourDifference > 0 ? hourDifference : 0) + '時間' : 'ー' }}</div>
      </div>
    </div>
  </div>
  <div class="final-treatment-child">
    <div class="parent-content">
      <caremoni-text-marquee [config]="config" [data]="dataMarquee"></caremoni-text-marquee>
    </div>
  </div>
</div>